import $ from 'jquery';

class Confirmer {
	
	constructor() {

		$(".confirm").each((i, element) => {
			if ($(element).hasClass("initialized")) {
				return;
			}
			$(element).click(e => {
				e.preventDefault();
				let location = $(element).attr("href");
        let post = $(element).data("post");

				this.modal("Confirm", $(element).data("message"), success => {
					if (success) {
            if (post) {
              $.ajax({
                data:post,
                success: (d, s) => {
                  window.location = location;
                }
              });
            } else {
              window.location = location;
            }
					}
				}, $(element).data("delete"));

			}).addClass("initialized");

		});

	}

	modal(title, message, callback, confirmDelete=false) {
		let div = $("<div></div>").addClass("modal fade");
		let dialog = $("<div></div>").addClass("modal-dialog");
		let contents = $("<div></div>").addClass("modal-content");
		let header = $("<div></div>").addClass("modal-header").html(
			'<button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>'
			).append(
			$("<h4></h4>").html(title).addClass("modal-title")
			);
		let body = $("<div></div>").addClass("modal-body").html($("<p></p>").html(message));

		let input = $("<input />").addClass("form-control");
		if (confirmDelete) {
			let alert = $("<p></p>").html("You <strong>CANNOT</strong> undo this operation").addClass("alert alert-danger");
			$(body).prepend(alert);

			let b = $("<p></p>").html("If you are sure, please write the word <code>DELETE</code> in the field below")
			$(body).append(b).append(input);
		}

		let footer = $("<div></div>").addClass("modal-footer");

		let cancel = $('<button type="button" class="btn btn-default">' + window.Lang.get("Cancel") + '</button>');
		let ok = $('<button type="button" class="btn btn-primary">' + window.Lang.get("Ok") + '</button>');

		$(cancel).click(e => {
			e.preventDefault();
			$(div).modal('hide');
			callback(false);
		});


		$(ok).click(e => {
			e.preventDefault();
			if (confirmDelete) {
				if ($(input).val() != "DELETE") {
					return;
				}
			}
			$(div).modal('hide');
			callback(true);

		});

		$(footer).html(cancel).append(ok);

		$(contents).html(header).append(body).append(footer);

		$(dialog).html(contents);
		$(div).html(dialog);


		$("body").append(div);


		$(div).on('hidden.bs.modal', function (e) {
		  $(div).remove();
		});

		$(div).modal('show');
	}

}

export default Confirmer;
